export default function getColumnType (columnName) {
  const columnType = {
    Alphanumeric: 'string',
    Numeric: 'number',
    Date: 'date',
    Currency: 'number',
  };
  return columnType[columnName] || null;
//   return columnType[columnName] || 'string';
};